import { styled as n, Typography as i, Box as f } from "@mui/material";
import { RONIN_VRF_ESIMATE_MINUTES as p, RONIN_VRF_ESIMATE_FEE as a } from "../../contract-lib/constants/contract.js";
import h from "../../temp-lib/components/share/apeiron/ApeironLinkButton.js";
import { useConfigContext as g } from "../../temp-lib/contexts/config/ConfigContext.js";
import { useTranslation as m, Trans as c } from "react-i18next";
import { jsx as t, jsxs as w } from "react/jsx-runtime";
const x = n(i)`
  font-size: 24px;
  font-weight: 500;
`, d = n(f)`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 18px;
  justify-content: center;
`, u = n(i)`
  strong {
    font-weight: 600;
  }
  font-weight: 300;
`, R = n(i)`
  strong {
    color: white;
    font-weight: 500;
  }
  color: #b1b3b3;
  font-size: 14px;
  line-height: 26px;
  font-weight: 300;
  white-space: pre-wrap;
`, T = n(h)`
  color: #ff5c00;
  font-size: 14px;
  font-weight: 400;
  vertical-align: unset;
`, V = (o) => {
  const {
    title: e
  } = o;
  return /* @__PURE__ */ t(x, {
    children: e
  });
}, b = (o) => {
  var s;
  const {
    skipDescription: e = !1
  } = o, {
    config: l
  } = g(), {
    t: r
  } = m();
  return /* @__PURE__ */ w(d, {
    children: [!e && /* @__PURE__ */ t(c, {
      children: /* @__PURE__ */ t(u, {
        children: r("wallet.ronin.vrf.description", {
          minute: p
        })
      })
    }), /* @__PURE__ */ t(R, {
      children: /* @__PURE__ */ t(c, {
        components: {
          learn: /* @__PURE__ */ t(T, {
            target: "_blank",
            url: (s = l.ronin) == null ? void 0 : s.walletVrf
          })
        },
        children: r("wallet.ronin.vrf.note", {
          fee: a
        })
      })
    })]
  });
};
export {
  b as RoninVRFDescription,
  V as RoninVRFTitle
};
//# sourceMappingURL=RoninVRFMessage.js.map
